"use client";

import {
  TRUST_PILOT_BUSINESS_UNIT_ID,
  TRUST_PILOT_URL,
} from "@shared/constants";

import BBB, { BBBStyle } from "@client/components/bbb";
import TrustBoxContainer, {
  TrustPilotTheme,
} from "@client/components/trust-pilot";

interface StepFooterParams {
  BBBWidgetStyle?: BBBStyle;
  text?: string;
  showBBBWidget?: boolean;
  trustPilotEnabled?: boolean;
  trustPilotTheme?: TrustPilotTheme;
}

export default function LeadFormStepFooter({
  BBBWidgetStyle = "blue",
  text,
  showBBBWidget = true,
  trustPilotEnabled = false,
  trustPilotTheme = "light",
}: StepFooterParams) {
  const trustPilotBusinessId: string = TRUST_PILOT_BUSINESS_UNIT_ID;
  const trustPilotURL: string = TRUST_PILOT_URL;

  const showTrustPilotWidget: boolean =
    trustPilotBusinessId !== "" && trustPilotURL !== "" && trustPilotEnabled;

  return (
    <>
      <span
        dangerouslySetInnerHTML={{
          __html: text || "Checking your options is free <br /> and won't affect your credit score.",
        }}
      ></span>
      {showTrustPilotWidget && (
        <TrustBoxContainer theme={trustPilotTheme} widgetType="MicroStar" />
      )}
      {showBBBWidget && <BBB style={BBBWidgetStyle} />}
    </>
  );
}
